<div class="step">
  <p class="title">{{ title }}</p>
  <p class="subtitle">{{ subtitle }}</p>
  <ng-content></ng-content>
  <button
    *ngIf="nextButton"
    class="td-btn-sm primary"
    [disabled]="!enableNextButton"
    (click)="selectResponse(USER_SELECTION.NEXT)"
  >
    Siguiente
  </button>
  <button *ngIf="backButton" class="td-btn-sm black" (click)="selectResponse(USER_SELECTION.BACK)">
    Volver
  </button>
  <button *ngIf="endButton" class="td-btn-sm primary" (click)="selectResponse(USER_SELECTION.END)">
    Finalizar
  </button>
</div>
